import React from 'react';
import { translate } from 'react-jhipster';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface KeepOrSellCardProps {
  count: number;
  onClick: () => void;
  onNavigate: (path: string) => void;
}

export const KeepOrSellCard = ({ count, onClick, onNavigate }: KeepOrSellCardProps) => {
  const safeCount = count > 0 ? count : 0;

  return (
    <Card className="action-paper" onClick={onClick}>
      <CardActionArea onClick={() => onNavigate('/home/#poTable')}>
        <CardContent sx={{ backgroundColor: '#F1F9F1' }}>
          <Grid container spacing={2}>
            <Grid item xs className="left-side-component-flex">
              <Typography variant="h6" sx={{ color: '#1b5e20' }}>
                <strong>{safeCount}</strong>
              </Typography>
            </Grid>
            <Grid item xs className="right-side-component-flex">
              <ImportExportIcon className="icon-card" sx={{ color: '#1b5e20' }} />
            </Grid>
          </Grid>
          <Typography variant="body2" sx={{ color: '#1b5e20' }}>
            {translate('home.topInfo.keepOrSell.title')}&nbsp;
            <Tooltip title={`${translate('home.topInfo.keepOrSell.tooltip')}`}>
              <InfoOutlinedIcon sx={{ fontSize: 14, cursor: 'pointer' }} />
            </Tooltip>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default KeepOrSellCard;
